{
    "Accessibility menu": "Menu Aksesibilitas",
    "Close": "Tutup",
    "Content adjustments": "Penyesuaian Konten",
    "Navigation adjustments": "Penyesuaian Navigasi",
    "Text Align": "Text Align",
    "Align Left": "Rata Kiri",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Sesuaikan Ukuran Font",
    "Highlight Title": "Sorot Judul",
    "Highlight Links": "Sorot Tautan",
    "Readable Font": "Font Mudah Dibaca",
    "Colour adjustments": "Penyesuaian Warna",
    "Dark Contrast": "Kontras Gelap",
    "Light Contrast": "Kontras Terang",
    "High Contrast": "Kontras Tinggi",
    "High Saturation": "Saturasi Tinggi",
    "Low Saturation": "Saturasi Rendah",
    "Monochrome": "Monokrom",
    "Tools": "Alat",
    "Reading Guide": "Panduan Membaca",
    "Big Cursor": "Kursor Besar",
    "Increase Font Size": "Perbesar Ukuran Font",
    "Decrease Font Size": "Perkecil Ukuran Font",
    "Letter Spacing": "Jarak Huruf",
    "Line Height": "Tinggi Baris",
    "Font Weight": "Ketebalan Font",
    "Dyslexia Font": "Font Disleksia",
    "Language": "Bahasa",
    "Accessibility widget": "Buka menu aksesibilitas",
    "Accessibility Profiles": "Profil Aksesibilitas",
    "Cognitive Disability": "Disabilitas Kognitif",
    "Seizure Safe": "Aman untuk Epilepsi",
    "Accessibility statement": "Pernyataan Aksesibilitas",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Hentikan Animasi",
    "Animation paused": "Animasi dijeda",
    "Reset all settings": "Atur Ulang Pengaturan",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
